import { render } from "./HTPunchBoardPlay.vue?vue&type=template&id=4203ca8b"
import script from "./HTPunchBoardPlay.vue?vue&type=script&lang=js"
export * from "./HTPunchBoardPlay.vue?vue&type=script&lang=js"

import "./HTPunchBoardPlay.vue?vue&type=style&index=0&id=4203ca8b&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__